import { Component, Input, Output, EventEmitter } from '@angular/core';

import { ContentSharingTypesEnum } from '../../enums/content-sharing-types.enum';
import { ContentSharingModel } from '../../models/content-sharing.model';

@Component({
    selector: 'agpr-content-sharing',
    templateUrl: './content-sharing.component.html',
    styleUrls: ['./content-sharing.component.scss'],
    standalone: false
})

export class ContentSharingComponent {
    @Input() id: string = null;
    @Input() content: ContentSharingModel = new ContentSharingModel();

    @Output() escape: EventEmitter<string> = new EventEmitter<string>();

    public contentSharingTypes = ContentSharingTypesEnum;

    /**
     * Performs the actions for when the user clicks a given share button. The actions for each type of sharing method
     * are different.
     *
     * @param {ContentSharingTypesEnum} type
     */
    shareContent(type: ContentSharingTypesEnum): void {
        switch (type) {
            case ContentSharingTypesEnum.facebook:
                this.shareFacebook();
                break;
            case ContentSharingTypesEnum.twitter:
                this.shareTweet();
                break;
            case ContentSharingTypesEnum.linkedin:
                this.shareLinkedin();
                break;
            case ContentSharingTypesEnum.email:
                this.shareEmail();
                break;
        }
    }

    /**
     * Opens a child window pre-populated with the facebook information.
     */
    shareFacebook(): void {
        const baseUrl = 'https://www.facebook.com/sharer/sharer.php?';

        const params = new URLSearchParams();
        params.set('u', this.content.facebook.url);

        const windowOptions: string[] = [
            'resizable',
            'scrollbars',
            'status',
            'height=500',
            'width=650'
        ];

        const win = window.open(baseUrl + params.toString(), '', windowOptions.join());
        win.opener = null;
    }

    /**
     * Opens a child window pre-populated with the tweet information.
     */
    shareTweet(): void {
        const baseUrl = 'https://twitter.com/intent/tweet?';

        const params = new URLSearchParams();
        params.set('text', this.content.tweet.body);
        params.set('url', this.content.tweet.url);

        const windowOptions: string[] = [
            'resizable',
            'scrollbars',
            'status',
            'height=400',
            'width=550'
        ];

        const win = window.open(baseUrl + params.toString(), '', windowOptions.join());
        win.opener = null;
    }

    /**
     * Opens a child window pre-populated with the linkedin information.
     */
    shareLinkedin(): void {
        const baseUrl = 'https://www.linkedin.com/shareArticle?';

        const params = new URLSearchParams();
        params.set('url', this.content.linkedin.url);

        const windowOptions: string[] = [
            'resizable',
            'scrollbars',
            'status',
            'height=500',
            'width=650'
        ];

        const win = window.open(baseUrl + params.toString(), '', windowOptions.join());
        win.opener = null;
    }

    /**
     * Opens the user's email client of choice pre-populated with the email information.
     */
    shareEmail(): void {
        const baseUrl = 'mailto:?';

        const params = new URLSearchParams();
        params.set('body', this.content.email.body);

        // Have to encode subject differently because mailto needs to use '%20' for spaces while URLSearchParams uses '+'.
        window.location.href = baseUrl + 'subject=' + encodeURIComponent(this.content.email.subject) + '&' + params.toString();
    }

    escapeMenu() {
        this.escape.emit(this.id);
    }
}
